import { render, staticRenderFns } from "./ReceiveLogin.vue?vue&type=template&id=0413ca07&scoped=true&"
import script from "./ReceiveLogin.vue?vue&type=script&lang=js&"
export * from "./ReceiveLogin.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveLogin.vue?vue&type=style&index=0&id=0413ca07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0413ca07",
  null
  
)

export default component.exports